import React, { useState, useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, Redirect } from "react-router-dom";
import HeaderLogo from './HeaderLogo';
import Navbar from './HeaderNavbar';
import SaveIcon from '../../assets/images-new/icons/save-icon-2.svg';
import TickIcon from '../../assets/images-new/icons/tick-white.svg';
import PrintIcon from '../../assets/images-new/icons/print-icon.svg';
import DownloadIcon from '../../assets/images-new/icons/download-icon.svg';
import '../../assets/scss/common/_header.scss';
import WpAPI from '../../WpApi';
import downloadResume from '../../downloadResume';
import { usePopup } from '../../context/PopupContext';
import { POPUP_TYPES, PAID_SERVICES, MEMBERSHIP, DASHBOARD_LINK, APP_DOMAIN, COVERLETTER_EXPERIENCE, COVERLETTER_FINALIZE, TP_REVIEW_URL } from '../../constants/constants';
import SignUpPopup from '../user/SignUpPopup';
import { userCompletesSectionsDownloadsPrintsOrShares as userCompletesSectionsDownloadsPrintsOrSharesAction } from '../../services/actions/actions';
import { removeBodyScroll } from '../../helper';
import { useUser } from '../../context/UserContext';
import { useResume } from '../../context/ResumeContext';
const SimpleHeader = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const popupbox = usePopup();
    const [showDownloadDD, setShowDownloadDD] = useState(false);
    const [spinner, setSpinner] = useState(false);
    const [btnLabel, setBtnLabel] = useState('Save');
    const [currentResume, setCurrentResume] = useState('');
    const [showLoginPopUp, setShowLoginPopUp] =  useState(false);
    const [loader, setLoader] = useState({download: false, save: false, printHandler: false});
    let cName = props.hasOwnProperty('className') ? (props.className != '' ? ` ${props.className}` : '') : '';
    const {
        checkMembership,
        plan,
        user
    } = useUser();
    const [redirect, setRedirect] = useState(false);
    //get props from context -- ResumeContext
    const contextProps = useResume();

    const mounted = useRef(false);

    useEffect(() => {
        mounted.current = true;
        return () => {
            mounted.current = false;
        };
    }, []);

    const checkMembershipAction = (callback = false, params = false) => {
        if(typeof callback == 'function' && mounted.current) setLoader({...loader, [callback.name]: true});
        checkMembership(() => {
            if(typeof callback == 'function'){
                callback(params);
                if(mounted.current) setLoader({...loader, [callback.name]: false});
            }
        });
    }

    const saveSpoof = () => {
        let isLoggedIn = WpAPI.isLoggedIn();
        if(isLoggedIn){
            if(PAID_SERVICES){
                if(plan == 'pro'){
                    setBtnLabel('Saved!');
                    setTimeout(() => {
                        setBtnLabel('Save');
                    }, 700);
                } else history.push(MEMBERSHIP)
            }else{
                setBtnLabel('Saved!');
                setTimeout(() => {
                    setBtnLabel('Save');
                }, 700);
                gaTrack('RT App', `Header`, `Login/Signup Popup`);
                ga4Track('app_header_save_button_popup', 'RT App', 'Login/Signup Popup');
            }
            gaTrack('RT App', `Header`, `Save Resume`);
            ga4Track('app_header_save', 'RT App', 'Save Resume');
        }else{
            setShowLoginPopUp(true);
            WpAPI.setRedirectCookie(location.pathname);
        }
    }
    const downloadHandler = (downloadFormat) => {
        // if(PAID_SERVICES){
        //     if(plan == 'pro'){
        //         downloadResume(contextProps, setSpinner, contextProps.downloadFormat);
        //     }else history.push(MEMBERSHIP);
        // }else{
        //     downloadResume(contextProps, setSpinner, contextProps.downloadFormat);
        // }
        downloadResume(contextProps, user, () => { 
            popupbox.close('download'); 
            popupbox.show('askfor_trustpilot_review', null, () => {
                window.open( TP_REVIEW_URL, '_blank');
            });
        }, downloadFormat, {type: 'resume', name: 'Resume' });
        if (window.innerWidth <= 780){
            gaTrack('RT App', `Quick Editor`, 'Mobile Download');
            ga4Track('app_quick_editor_mobile_download', 'RT App', 'Mobile Download');
        }
    }
    const openPrintWindow = (v) => {
        let isLoggedIn = WpAPI.isLoggedIn();
        if(isLoggedIn){
            userCompletesSectionsDownloadsPrintsOrShares();
            // if (!navigator.onLine) {
            //     alert("You seem to be offline. Please try again later.");
            //     return false;
            // }else{
                if(PAID_SERVICES){
                    if(plan == 'pro'){
                        window.print();
                    }else history.push(MEMBERSHIP);
                }else{
                    window.print();
                }
            //}
        }else{
            setShowLoginPopUp(true);
            WpAPI.setRedirectCookie(location.pathname);
        }
    }
    const printHandler = (params) => {
        localStorage.setItem('clickAction', 'print');
        openPrintWindow(params.e);
        const ec = (window.innerWidth < 769 ? 'app_quick_editor_print_mobile' : 'app_quick_editor_print');
        const el = (window.innerWidth < 769 ? 'Mobile Print' : 'Print');
        gaTrack('RT App', `Quick Editor`, el);
        ga4Track(ec, 'RT App', el);
    }
    useEffect(() => {
        popupbox.configurePopup(POPUP_TYPES);
    }, []);

    useEffect(() => {
        customEventListener('keydown');
    }, []);

    const customEventListener = (eventName) => {
        window.addEventListener(eventName, function (e) {
            // if (!navigator.onLine) {
            //     alert("You seem to be offline. Please try again later.");
            //     return false;
            // } 
            // else if ((e.ctrlKey || e.metaKey) && (e.key == "p" || e.charCode == 16 || e.charCode == 112 || e.keyCode == 80)) {
            //     printHandler();
            // }
        });
    }

    const download = () => {
        localStorage.setItem('clickAction', 'download');
        //setShowDownloadDD(!showDownloadDD);
        if(WpAPI.isLoggedIn()){
            // if(PAID_SERVICES){
            //     if(plan == 'pro'){
            //         popupbox.show('download', null, () => downloadHandler())
            //     }else history.push(MEMBERSHIP);
            // }else{
            //     popupbox.show('download', null, () => downloadHandler())
            // }
            /**
             * #993: Any logged in users can download the resume in the text format. 
             * Action: Removed the above code snippet having PAID_SERVICES and plan check.
             * Date: 2023-07-21
             */
            popupbox.show('download', null, (params) => {
                downloadHandler(params.downloadFormat);
                userCompletesSectionsDownloadsPrintsOrShares();
                ga4Track('app_header_download', 'RT App', 'Header Download');
            }, {plan: contextProps.plan, entity: {type: 'resume', name: 'Resume' }});
        }else{
            setShowLoginPopUp(true);
            WpAPI.setRedirectCookie(location.pathname);
        }
    }

    const userCompletesSectionsDownloadsPrintsOrShares = () => {
        dispatch(userCompletesSectionsDownloadsPrintsOrSharesAction(contextProps.resume, 'currentResume')).then(res => {
            if(res.completed){
                const ec = (PAID_SERVICES && plan == 'pro' ? 'app_editor_finalizations' : 'app_editor_finalizations_free');
                const el = (
                    PAID_SERVICES && plan == 'pro' 
                    ? 'User completes sections: Downloads, Prints or Shares' 
                    : 'Free user completes sections: tries to download, print, share'
                );
                ga4Track(ec, 'RT App', el)
            }
        })
    }

    const redirectTo = (path) => {
        //history.push(path)
        window.location.href = `${APP_DOMAIN}/${path}`
    }
    if (redirect) {
        return <Redirect to={''} push = {true}/>
    }
    const currentPath = window.location.pathname;
    return (<>
        <div className={`app-container no-print${ cName }`}>
            <header className={`header${props?.cssClass ? ' ' + props.cssClass : ''}`}>
                <div className={`header-main ${currentPath === COVERLETTER_FINALIZE ? 'finalize-view' : ''}`}>
                    <HeaderLogo clickAction={(e) => popupbox.show('exit', null, () => (redirectTo(DASHBOARD_LINK)))} />
                    {props.hasOwnProperty('showDownload') && props.showDownload ? <div className="header-button-wrap">
                        <button className={`save-button${btnLabel != 'Save' ? ' green' : ''}`} onClick={() => checkMembershipAction(saveSpoof)}>
                            {btnLabel == 'Save' ? <SaveIcon /> : <TickIcon />}
                            <span>{btnLabel}</span>
                        </button>
                        <button className={`print-button`} onClick={(e) => {
                            checkMembershipAction(printHandler, {e: e});
                        }}>
                            <PrintIcon />
                            <span>{loader.printHandler ? 'Loading...' : 'Print'}</span>
                        </button>
                        <div className="download-list-wrap">
                            <button className="download-button" onClick={() => {checkMembershipAction(download), removeBodyScroll(true)}}>
                                <i className="new-icon-download"><DownloadIcon /></i>
                                {/* <span>Download <i className="icon-chevron-left"></i></span> */}
                                <span className='quick-download'>{loader.download ? 'Loading...' : 'Download'}</span>
                            </button>
                            {showDownloadDD ? <div className="download-list">
                                <ul>
                                    <li> Export as DOCX</li>
                                    <li onClick={() => {
                                        downloadHandler('pdf');
                                    }}>Export as PDF</li>
                                    <li>Text Download</li>
                                    <li>Share as a link</li>
                                </ul>
                            </div> : ''}
                        </div>
                    </div> : <Navbar />}

                </div>
            </header>
        </div>
        {showLoginPopUp ? <SignUpPopup setShowLoginPopUp={(c) => { setShowLoginPopUp(c) }} /> : ''}
    </>);
}

export default SimpleHeader;